exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reliability-observation-setup {\n  flex: 1 0 auto;\n  padding-bottom: 30px;\n  font-size: 18px;\n}\n.reliability-observation-setup table.gold-standard-observations-table {\n  font-size: 16px;\n}\n.reliability-observation-setup .observation-parameters {\n  margin: 7px 0;\n}\n.reliability-observation-setup .observation-parameters .total-minutes {\n  margin: 10px 0;\n}\n.reliability-observation-setup button.start-observation {\n  margin-top: 30px;\n}\n.reliability-observation-setup .validation-error {\n  color: #f00;\n  font-style: italic;\n}\n.reliability-observation-setup .select-students .select-students-controls {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n.reliability-observation-setup .select-students .select-students-controls .form-group {\n  width: auto;\n}\n.reliability-observation-setup button:active,\n.reliability-observation-setup button.active,\n.reliability-observation-setup button:focus {\n  outline: none !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/ReliabilityObservationSetup.styl
// module id = 1913
// module chunks = 1